import { memo } from "react";
import SuccessStep from "@/components/intake/SuccessStep";
import type { IntakeData } from "@/lib/types";

interface SuccessCardProps {
  data: IntakeData;
}

export const SuccessCard = memo(function SuccessCard({ data }: SuccessCardProps) {
  return (
    <div className="w-full max-w-2xl">
      <SuccessStep data={data} />
    </div>
  );
});
